import React from "react";
import { useTranslation } from 'react-i18next';




const InvoiceGeneratorInfo: React.FC = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: "⚡",
      title: t('text.title.instantBills'),
      description: t('text.instantBills')
    },
    {
      icon: "📱",
      title: t('text.title.availableOnAllDevices'),
      description: t('text.availableOnAllDevices')
    },
    {
      icon: "✅",
      title: t('text.title.userTrust'),
      description: t('text.userTrust'),
    },
    {
      icon: "🆓",
      title: t('text.title.free'),
      description: t('text.free')
    },
    {
      icon: "📷",
      title: t('text.title.paymentBarcode'),
      description:
      t('text.paymentBarcode'),
    }
  ];

  return (
    <section className="container py-5">
      <div className="card shadow-lg rounded-3 p-4 border">
        <header className="text-center mb-4">
          <h2 className="display-4 text-primary mb-3">
            {t('text.headline.whyUseOurApp')} <span className="text-info">{t('text.headline.invoiceGenerator')}</span>
          </h2>
          <p className="lead text-muted">
          {t('text.simpleAndSafeWithQR')}
          </p>
        </header>

        <div className="row g-4">
          {features.map((item, idx) => (
            <div key={idx} className="col-md-6">
            <div className="d-flex align-items-center">
              <div className="fs-1 me-3">{item.icon}</div>
              <div>
                <h5 className="h5 mb-0">{item.title}</h5>
                <p className="text-muted mb-0">{item.description}</p>
              </div>
            </div>
          </div>
          
          ))}
        </div>

        <div className="border-top mt-5 pt-4">
          <h3 className="h4 text-secondary">{t('text.title.howToUse')}</h3>
          <ul className="list-unstyled">
            <li className="d-flex align-items-center gap-3">
              <span className="fs-4 mb-0">⬇️</span>
              <p className='mb-0'>
                <strong>{t('text.title.invoiceDownload')}:</strong> {t('text.invoiceDownload')}
              </p>
            </li>
            <li className="d-flex align-items-center gap-3">
              <span className="fs-4 mb-0">🔒</span>
              <p className='mb-0'>
                <strong>{t('text.title.storage')}:</strong> {t('text.storage')}
              </p>
            </li>
            <li className="d-flex align-items-center gap-3">
              <span className="fs-4 mb-0">⚙️</span>
              <p className='mb-0'>
                <strong>{t('text.title.templateCustomization')}:</strong> {t('text.templateCustomization')}
              </p>
            </li>
          </ul>
        </div>
        {/* Tehnički uvjeti */}
        <div className="border-top mt-5 pt-4">
          <h3 className="h4 text-secondary"> {t('text.title.tehnicalConditions')}</h3>
          <ul className="list-unstyled">
            <li className="d-flex align-items-center gap-3">
              <span className="fs-4 mb-0">🌐</span>
              <p className="mb-0">
                <strong>{t('text.title.supportedBrowsers')}:</strong> {t('text.supportedBrowsers')}
              </p>
            </li>
            <li className="d-flex align-items-center gap-3">
              <span className="fs-4 mb-0">🔧</span>
              <p className="mb-0">
                <strong>{t('text.title.setup')}:</strong> {t('text.setup')}
              </p>
            </li>
            <li className="d-flex align-items-center gap-3">
              <span className="fs-4 mb-0">💾</span>
              <p className="mb-0">
                <strong>{t('text.title.invoiceStorage')}:</strong> {t('text.invoiceStorage')}
              </p>
            </li>
          </ul>
        </div>
      </div>



      

    </section>
  );
};

export default InvoiceGeneratorInfo;
